import axios from 'axios'

const token = localStorage.getItem("token");
const headers = token ? {"Authorization": `Bearer ${token}`} : {}
const api = axios.create({
    // baseURL: 'http://localhost:5000',
    baseURL: process.env.VUE_APP_BASE_URL,
    
    headers
});
// axios.defaults.baseURL='http://localhost:5000/';
axios.defaults.baseURL=process.env.VUE_APP_BASE_URL;
export default api;